window.US_PANEL_GROUPS = {
  order: ['Cancer', 'Cardiac', 'Additional'],

  labels: { Cardiac: 'Heart' },
  label: function (g) { return (this.labels && this.labels[g]) || g; },
  color: { Cancer: '#33382c', Cardiac: '#576049', Additional: '#848c73' },

  of: function (name) {
    var n = (name || '').toLowerCase();
    if (n.indexOf('cancer') > -1) return 'Cancer';
    if (n.indexOf('heart') > -1 || n.indexOf('cardio') > -1 ||
        n.indexOf('rhythm') > -1 || n.indexOf('circulation') > -1) return 'Cardiac';
    return 'Additional';
  },

  group: function (cats) {
    var self = this;
    return this.order.map(function (g) {
      var members = cats.filter(function (c) { return self.of(c.name) === g; });
      return {
        name: self.label(g),
        key: g,
        color: self.color[g],
        cats: members,
        count: members.reduce(function (s, c) { return s + (c.count || 0); }, 0)
      };
    }).filter(function (g) { return g.cats.length; });
  }
};
